import { useMy } from '@/hooks/useMy';

export const DEFAULT_PER_SCAN_AI_BUDGET = 250;
export const MIN_PER_SCAN_AI_BUDGET = 1;
export const MAX_PER_SCAN_AI_BUDGET = 10000;
export const PER_SCAN_AI_BUDGET_SETTING_NAME = 'ai-scan-budget';

interface UsePerScanAIBudgetOptions {
  email?: string;
}

export function usePerScanAIBudget(
  options?: UsePerScanAIBudgetOptions
): number {
  const email = options?.email;
  const { data } = useMy(
    { resource: 'configuration' },
    email ? { email, doNotImpersonate: true } : undefined
  );
  const raw = data?.find(
    configuration => configuration.name === PER_SCAN_AI_BUDGET_SETTING_NAME
  )?.value;
  const parsed = Number(raw);
  return raw !== undefined &&
    Number.isFinite(parsed) &&
    parsed >= MIN_PER_SCAN_AI_BUDGET &&
    parsed <= MAX_PER_SCAN_AI_BUDGET
    ? parsed
    : DEFAULT_PER_SCAN_AI_BUDGET;
}
